module.exports = __webpack_public_path__ + "img/s00136.84078b8d.jpg";